import { render, staticRenderFns } from "./TotalFsToday.vue?vue&type=template&id=4af0158d&"
import script from "./TotalFsToday.vue?vue&type=script&lang=js&"
export * from "./TotalFsToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports